<script lang="ts">
    import TreeView from "./TreeView.svelte"
    import type { ITreeViewNode } from "./TreeView/iTreeViewNode"
    import type { ITreeViewNodeProvider } from "./TreeView/iTreeViewNodeProvider"
    import { documentationsStore } from "../stores/documentationsDataStore"

    export let documentationIDs:Array<string>
    $: generateDocumentationTreeViewNodes(documentationIDs) 

    let documentationTreeViewNodes:Array<ITreeViewNode> = new Array<ITreeViewNode>()

    function generateDocumentationTreeViewNodes(documentationIDs:Array<string>):void {
      documentationTreeViewNodes.length = 0 //Clear the old TreeViewNodes
      for (let documentationID of documentationIDs) {
        const documentationData:ITreeViewNodeProvider|undefined = $documentationsStore.get(documentationID);
        if (documentationData != undefined) {
          documentationTreeViewNodes.push(documentationData.getTreeViewNode())
        }
      }
      documentationTreeViewNodes = documentationTreeViewNodes
    }
</script>

{#if documentationTreeViewNodes.length > 0}
<div class="bg-darkBackHigh text-darkForeHigh text-lg px-3 my-3">Documentation</div>
<TreeView class="text-darkFore ml-3" label={null} text={null} children={documentationTreeViewNodes}></TreeView>
{/if}
